// React Dependencies
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// External Dependencies
import PropTypes from 'prop-types';
import { useSelector, connect } from 'react-redux';

// Internal Dependencies
import MText from '../../../../../components/Common/MText';
import MButton from '../../../../../components/MButton';
import Colours from '../../../../../styles/colours';
import loyaltyAction from '../../../../../actions/loyalty';
import HeaderSkeleton from './Skeleton';
import { LoyaltyHeaderMenu } from '../../../../../common/constants';
import { IsEmpty } from '../../../../../common/checks';

const tabList = Object.values(LoyaltyHeaderMenu);

const Header = (props) => {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const queryTab = query.get('tab');

  const { tab: selectedTab, selectedLoyaltyProgram } = useSelector((state) => state.loyalty);
  const loyaltyCardId = !IsEmpty(selectedLoyaltyProgram?.id) ? selectedLoyaltyProgram.id : null;

  const handleChangeTab = (tab) => {
    props.updateLoyaltyTab(tab);
    history.replace(`${history.location.pathname}?tab=${encodeURIComponent(tab)}`);
  };

  useEffect(() => {
    if (!IsEmpty(queryTab) && tabList.includes(queryTab)) {
      handleChangeTab(queryTab);
    } else {
      handleChangeTab(LoyaltyHeaderMenu.Design);
    }
  }, []);

  if (IsEmpty(loyaltyCardId)) {
    return <HeaderSkeleton />;
  }

  return (
    <div className="d-flex flex-column">
      <MText
        size={12}
        colour={Colours.Gray1}
        className="mb-2 "
        text={`Loyalty Programme ID: ${loyaltyCardId || '-'}`}
      />

      <div
        className="d-inline-block align-items-center position-relative"
        style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '105%', left: '-11px' }}
      >
        {tabList.map((tab) => (
          <MButton
            key={tab}
            variant="text"
            colour={Colours.Transparent}
            className="mr-3"
            textStyle={{ fontWeight: tab === selectedTab ? 'bold' : 'normal' }}
            onClick={() => handleChangeTab(tab)}
            textSize={13}
            text={tab}
          />
        ))}
      </div>
    </div>
  );
};

Header.propTypes = {
  updateLoyaltyTab: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  updateLoyaltyTab: (tab) => loyaltyAction.updateLoyaltyTab(dispatch, tab),
});

export default connect(null, mapDispatchToProps)(Header);
